export interface ConditionalFormProps extends React.PropsWithChildren {
    condition: boolean;
}

export const ConditionalForm: React.FC<ConditionalFormProps> = (props) => {
    const { condition, children } = props;

    return condition ? <form onSubmit={(ev) => ev.preventDefault()}>{children}</form> : children;
};
